import { MenuItem } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { CustomSelect, CustomTextField, CustomButton, HeaderFilterBox } from '../../../common';
import { useRecLegalEntities } from '../../../hooks/useLegalEntities';

const PaymentsFilters = ({ filters, setFilters, handleFilter, onExport, isExporting }) => {
  const { data: entidadesRec = [] } = useRecLegalEntities();

  const handleChange = (e) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const filterStyles = {
    ml: { xs: 0, md: 2 },
    mt: 0,
    width: { xs: '100%', sm: '48%', md: '15%' },
    mb: { xs: 1, md: 0 },
  };

  const filterStylesMedium = {
    ml: { xs: 0, md: 2 },
    mt: 0,
    width: { xs: '100%', sm: '68%', md: '30%' },
    mb: { xs: 1, md: 0 },
  };

  return (
    <HeaderFilterBox
      sx={{
        gap: 1,
        width: '100%',
      }}
    >
      <CustomTextField
        label="Fecha Desde"
        type="date"
        name="startDate"
        value={filters.startDate}
        onChange={handleChange}
        size="medium"
        shrinkLabel={true}
        sx={filterStyles}
      />
      <CustomTextField
        label="Fecha Hasta"
        type="date"
        name="endDate"
        value={filters.endDate}
        onChange={handleChange}
        size="medium"
        shrinkLabel={true}
        sx={filterStyles}
      />
      <CustomSelect
        label="Entidad Recaudadora"
        name="entidadSeleccionada"
        value={filters.entidadSeleccionada}
        onChange={handleChange}
        size="medium"
        sx={filterStylesMedium}
      >
        <MenuItem value="todas">Todas</MenuItem>
        {entidadesRec.map((entidad) => (
          <MenuItem key={entidad.uuid} value={entidad.uuid}>
            {entidad.legal_business_name}
          </MenuItem>
        ))}
      </CustomSelect>
      <CustomButton
        variant="contained"
        onClick={handleFilter}
        sx={{ height: '56px', alignSelf: 'end', ...filterStyles }}
      >
        Buscar
      </CustomButton>
      <CustomButton
        variant="base"
        startIcon={<CloudDownloadIcon />}
        onClick={onExport}
        disabled={!filters.startDate || !filters.endDate || isExporting}
        sx={{ maxWidth: '200px', height: '56px', alignSelf: 'end', ...filterStylesMedium }}
      >
        {isExporting ? 'Generando...' : 'Exportar XLSX'}
      </CustomButton>
    </HeaderFilterBox>
  );
};

export default PaymentsFilters;
